import styled, {createGlobalStyle} from "styled-components";
import {Select, DatePicker, Button} from "antd";

export const SelectField = styled(Select)`
    width: 100%;
`;

export const ImgBg = styled.div`
    height: 150px;
    border: 4px #5b5f63 solid;
    box-sizing: content-box;
    border-radius: 4px;
    cursor: ${props => (props.isEdit ? "unset" : "pointer")};
    background-image: url(${props => props.src});
    width: 150px;
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: ${props => (props.isEdit ? "flex-end" : "center")};
    align-items: ${props => (props.isEdit ? "flex-start" : "center")};
    z-index: 1;
`;

export const IconContainer = styled.div`
    background: #5b5f63;
    height: fit-content;
    border-bottom-left-radius: 4px;
    padding-left: 5px;
    cursor: pointer;
    z-index: 2;
    & > span {
        color: white;
        font-size: 20px;
    }
`;

export const Img = styled.img`
    height: 400px;
`;

export const DatePickerField = styled(DatePicker)`
    width: 100%;
`;

export const GeolocateButton = styled(Button)`
    position: absolute !important;
    top: 10px !important;
    left: 10px !important;

    border: none;
    box-shadow: 1px 1px 4px 0.1px rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    color: #666666;
    outline: none;
    &:hover,
    &:focus,
    &:active {
        color: #000000;
        outline: none;
    }
`;

// RangePicker varsayilan olarak iki ay paneli acar; basvuru tarihi filtresinde
// tek ay gosterebilmek icin ikinci panel gizlenip ileri butonlari ilk panelin
// ustune tasiniyor (antd 4'te tek panel icin prop yok)
export const SingleMonthRangePickerStyle = createGlobalStyle`
    .single-month-range-picker {
        .ant-picker-panels {
            position: relative;
            width: auto !important;
        }

        /* Ay/yil secim modunda tek panel render edildigi icin kardes secici
           kullaniliyor; yoksa acilan tek panel de gizlenirdi */
        .ant-picker-panels > .ant-picker-panel + .ant-picker-panel {
            width: 0;

            .ant-picker-header {
                position: absolute;
                top: 0;
                right: 0;
                border-bottom: none;
            }

            .ant-picker-header-view,
            .ant-picker-body {
                display: none;
            }
        }
    }
`;
